(function (upp, $) {
    'use strict';

    /**
     * Read the content of this element and resolve the url to open
     */
    upp.directive('htmlLinks', [ 'urlResolver',
        function (urlResolver) {
            return {
                restrict: 'A',
                link: function (scope, $element) {
                    $($element[0]).on('click', 'a', function(e) {

                        var $this = $(this);
                        var href = $this.attr('href');

                        // Element has own click function, this directive dont do anything
                        if (this.onClick || this.onclick)
                            return;

                        if (!href)
                            return;

                        e.preventDefault();
                        urlResolver.open(href);

                    });
                }
            }
        }]);

})(upp, window.jQuery);


// WEBPACK FOOTER //
// ./src/app/common/directives/html_links-directive.js